import React, { useEffect, useState } from 'react'
import { Typography, List, ListItem, Divider, ListItemText, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, DialogContentText, Checkbox, FormControlLabel } from "@mui/material";
import { createStyles, Theme } from '@mui/material/styles';
import { IApplicationNotes } from '../../../Interfaces/Application/IApplicationNotes';
import { IEmployee } from '../../../Interfaces/Admin/IEmployee';
import { useSelector } from "react-redux";
import { AppState } from '../../../store/rootReducer';
import { hasValue } from '@amsanalytics/react-shared-library';

interface NotesDialogProps {
  open: boolean;
  onClose(): void;
  notes: IApplicationNotes[];
  canAddNote: boolean;
  employee: IEmployee;
  mode?: 'multiple' | 'single';
  onSave: (notes: { note: string, isDecisionNote: boolean, createdDate: Date }[]) => void;
}

// const useStyles: any = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       width: '100%',
//       maxWidth: 400,
//       backgroundColor: theme.palette.background.paper,
//     },
//     inline: {
//       display: 'inline',
//     },
//   }),
// );

const NotesDialog: React.FC<NotesDialogProps> = (props) => {
  const employees = useSelector((state: AppState) => state.applications.employees);
  const [noteText, setNoteText] = useState<string>("");
  const [isDecisionNote, setIsDecisionNote] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [notes, setNotes] = useState<Partial<IApplicationNotes>[]>(props.notes || []);
  const [disableSave, setDisableSave] = useState<boolean>(true);
  // const classes = useStyles();
  
  useEffect(() => {
    setNotes(props.notes);
  }, [props.notes]);

  const handleAdd = () => {
    if (noteText) {
      setDisableSave(false)
      const updatedNotes = [
        ...notes, 
        { 
          createdDate: new Date(), 
          note: noteText, 
          isDecisionNote: isDecisionNote, 
          employeeId: props.employee.id, 
          applicationNoteRoles: [] 
        }];
      setNotes(
        updatedNotes
      )
      setNoteText('');
      setErrorMessage('');
      setIsDecisionNote(false);
      if(props.mode === 'single') {
        saveNotes(updatedNotes, props, setNotes, setDisableSave);
      }
    } else {
      setErrorMessage('You must enter some note text.');
    }
  }
  const saveNotes = (notes: Partial<IApplicationNotes>[], props: NotesDialogProps, setNotes: React.Dispatch<React.SetStateAction<Partial<IApplicationNotes>[]>>, setDisableSave: React.Dispatch<React.SetStateAction<boolean>>) => {
    const notesToSave = notes.filter(n => n.id === undefined && n.note !== undefined).map(n => {
      return { note: n.note!, isDecisionNote: n.isDecisionNote ?? false, createdDate: n.createdDate as Date };
    });
    setDisableSave(true);
    props.onSave(notesToSave);    
  }
  const dialogContentTextStyle = {
    width: '100%',
    maxWidth: 400,
    backgroundColor: 'white',
  };
  return (
    <>
      <Dialog open={props.open} onClose={props.onClose} aria-labelledby="form-dialog-title"
        maxWidth="sm" fullWidth
      >
        <DialogTitle id="form-dialog-title">Application Notes</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {props.mode !== 'single' && <List 
              style={dialogContentTextStyle}
            >
              {notes.filter(n => n.applicationNoteRoles?.length === 0).map((n, key) => {
                const employee = employees.find(e => e.id === n.employeeId);
                return (
                  <React.Fragment key={key}>
                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary={new Date(n.createdDate!).toLocaleString()}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              style={{display: 'inline'}}
                              color="textPrimary"
                            >
                              {employee?.firstName} {employee?.lastName}
                            </Typography>
                            {' '}• <span style={{ whiteSpace: 'pre-wrap' }}>{n.note}</span> {n.isDecisionNote && <span>{' '}• Decision Note</span>}
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider component="li" />
                  </React.Fragment>
                )
              })}
            </List>}
          </DialogContentText>
          {props.canAddNote && (
            <>
              <TextField
                autoFocus
                margin="dense"
                id="note-text"
                label="Note Text"
                value={noteText}
                onChange={(e) => {
                  setNoteText(e.currentTarget.value);                  
                  if(hasValue(e.currentTarget.value) && props.mode === 'single') {
                    setDisableSave(false);
                  }
                }}
                fullWidth
                multiline
                error={!!errorMessage}
                helperText={errorMessage}
              />
              <FormControlLabel
                label="Decision Note (Visible to users in CRM)"
                control={
                  <Checkbox
                    size='small'
                    checked={isDecisionNote || false}
                    color='primary'
                    onChange={() => setIsDecisionNote(!isDecisionNote)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                }
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            {props.mode !== 'single' && props.canAddNote && (
              <Button style={{ marginLeft: '15px' }} variant="contained" onClick={handleAdd} color="primary">
                Add Note
              </Button>
            )}
            {props.mode === 'single' && props.canAddNote && <div></div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Button variant="outlined" 
                onClick={() => {
                  setNoteText('');
                  props.onClose();
                }} color="secondary" style={{ color: 'black', borderColor: 'black', marginRight: '10px' }}>
                Cancel
              </Button>
              <Button
                variant="outlined"
                disabled={disableSave}
                onClick={() => {
                  if(props.mode === 'single') {
                    handleAdd();
                  } else {
                    saveNotes(notes, props, setNotes, setDisableSave);
                  }
                }}
                color="primary">
                Save
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog></>)
}

export default NotesDialog;


